module.exports = __webpack_public_path__ + "static/media/fb.41351eb3.png";